<template>
    <div class="home">
        <b-container fluid>
            <h1>COVID-19 Interview - Admin</h1>

            <b-row class="mb-4">
                <b-col>                    
                    <b-button variant="primary" href="admin/search">MEDSS Import Review Bin</b-button>
                </b-col>
            </b-row>

                  <b-row class="mb-4">
        <b-col>
          <b-button variant="primary" @click="exportData">Export Recent Submissions</b-button>
        </b-col>
      </b-row>

        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import fileDownload  from 'js-file-download'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

export default {
  components: {
  },
  
  data: () => ({
      
  }),
  
  created() {
  },

  computed: {
  },

  methods: {
    exportData() {
        let requestConfig = {
              //responseType: 'blob', 
             // headers: {
            //    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              //},
              params: {         
              }
            }

         axios.get(`${process.env.VUE_APP_API_BASE_URL}/search/export`, requestConfig)
                .then(response => {
                  const buf = Buffer.from(response.data.body, 'base64')
                  fileDownload(buf, 'submissions.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                })
        
    },
  },

  mounted() {
  
  }
  
}
</script>

<style>
@media only screen and (max-width: 750px) {
  .vue-form-wizard .wizard-nav {
        display: none !important;
    }
    .vue-form-wizard .wizard-nav-pills {
        display: none !important;
    }
    .vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {
        display: none !important;
    }

    .vue-form-wizard .wizard-btn {
        min-width: 120px !important;
    }
}

.vue-form-wizard .wizard-nav-pills>li.active>a .wizard-icon {
    color: white !important;
}

.vue-form-wizard .wizard-tab-content {
    min-height: 100px;
    padding: 30px 20px 10px;
    margin-bottom: 36px;
}


    
</style>